import { template as template_6f2d5d95b92c4d3090cc952c9c9290bd } from "@ember/template-compiler";
import Component from '@glimmer/component';
import LocaleMap from 'eflex/util/locale-map';
import { service } from '@ember/service';
import { tracked } from '@glimmer/tracking';
import { capitalize } from '@ember/string';
import { toLower } from 'ramda';
import BsDropdown from 'ember-bootstrap/components/bs-dropdown';
import BsButton from 'eflex/components/bs-button';
import FaIcon from '@fortawesome/ember-fontawesome/components/fa-icon';
import { fn, concat } from '@ember/helper';
import { t } from 'ember-intl';
import { transitionTo } from 'eflex/helpers';
import { on } from '@ember/modifier';
import StandardModal from 'eflex/components/standard-modal';
export default class UserDropdown extends Component {
    @service
    currentUser;
    @service
    session;
    languages = LocaleMap;
    @tracked
    showLogoutModal = false;
    get user() {
        return this.currentUser.user;
    }
    get userRole() {
        return this.user?.role;
    }
    get userAbbreviation() {
        if (!this.user) {
            return null;
        }
        return capitalize((this.user.userName.slice(0, 2)));
    }
    userColor(userRole) {
        switch(userRole){
            case 'Admin':
                {
                    return 'orange';
                }
            case 'User':
                {
                    return 'primary';
                }
            case 'ViewOnly':
                {
                    return 'secondary';
                }
        }
    }
    noHide = ()=>{
        return false;
    };
    languageChanged = (language)=>{
        return this.currentUser.changeLanguage.perform(language.lang);
    };
    logOut = ()=>{
        this.session.invalidate();
    };
    static{
        template_6f2d5d95b92c4d3090cc952c9c9290bd(`
    <BsDropdown
      class="user-dropdown-menu"
      @direction={{if @widePageLayout "bottom" "right"}}
      @closeOnMenuClick={{false}}
      ...attributes
    as |dd|>
      <dd.toggle class="user-dropdown">
        {{#if @widePageLayout}}
          <BsButton
            class="rounded-circle text-uppercase profile-image p-0"
            @size="md"
            @type={{this.userColor this.userRole}}
          >
            {{this.userAbbreviation}}
          </BsButton>
        {{else}}
          <BsButton
            @type="epicor-nav"
            class="text-uppercase p-0"
          >
            <img
              src='/images/icons/account-settings.svg'
            />
          </BsButton>
        {{/if}}
      </dd.toggle>

      <dd.menu class="
        dropdown-menu-epicor
        shadow
        overflow-visible
        fs-3
        p-0
        {{if @noChrome "dropdown-menu-dark mt-1" "ms-1"}}"
      as |menu|>
        <menu.item>
          <div class="
            dropdown-item-text
            user-option
            pb-3
            border-bottom
            {{if @noChrome "border-gray-600 p-3" "border-gray-200 p-2"}}"
          >
            <div class="
              fs-5
              text-uppercase
              fw-bold
              mb-2
              {{if @noChrome "text-gray-300" "text-gray-500"}}"
            >
              {{t "user.menu.account"}}
            </div>
            <div class="row align-items-center g-2">
              <div class="col-auto">
                <div class="
                  profile-image
                  text-bg-{{this.userColor this.userRole}}
                  d-flex
                  align-items-center
                  justify-content-center
                  rounded-circle
                  user-select-none
                  fs-3
                  text-uppercase
                  fw-bold
                  m-0">
                  {{this.userAbbreviation}}
                </div>
              </div>
              <div class="col-auto">
                <div class="fw-semibold {{if @noChrome "text-white" "text-body"}}">
                  {{this.user.userName}}
                </div>
                {{#if this.user}}
                  <div class="fs-5 fw-semibold {{if @noChrome "text-gray-300" "text-gray-500"}}">
                    {{t (concat "user.menu." (toLower this.userRole))}}
                  </div>
                {{/if}}
              </div>
            </div>
          </div>
        </menu.item>

        <div class="py-1 border-bottom {{if @noChrome "border-gray-600" "border-gray-200"}}">
          {{#if @showHeaderButtons}}
            <menu.item>
              <div
                class="user-option user-profile dropdown-item {{if @noChrome "p-3" "fs-4"}}"
                {{on "click" (transitionTo 'settings')}}
              >
                {{t "user.menu.userSettings"}}
              </div>
            </menu.item>
          {{/if}}

          <menu.item>
            <div class="user-option dropdown-item p-0">
              <BsDropdown
                class="z-top-menu"
                @direction="right"
              as |languageDropdown|>
                <languageDropdown.toggle
                  class="
                    language-dropdown
                    d-flex
                    align-items-center
                    {{if @noChrome "p-3" "fs-4 p-2"}}"
                  >
                  {{t "settings.language"}}
                  <FaIcon @icon="caret-right" @prefix="fas" class="ms-auto" />
                </languageDropdown.toggle>

                <languageDropdown.menu
                  class="
                    dropdown-menu
                    eflex-scroll
                    shadow
                    {{if @noChrome "dropdown-menu-dark me-1" "ms-1"}}"
                  as |subMenu|>
                  {{#each this.languages as |language|}}
                    <subMenu.item>
                      <div
                        class="language-option dropdown-item {{if @noChrome "p-3" "fs-4"}}"
                        {{on "click" (fn this.languageChanged language)}}
                      >
                        {{language.label}}
                      </div>
                    </subMenu.item>
                  {{/each}}
                </languageDropdown.menu>
              </BsDropdown>
            </div>
          </menu.item>
        </div>
        <div class="py-1">
          <menu.item>
            <div class="user-option dropdown-item fs-4 p-0">
              {{#if this.session.isAuthenticated}}
                <a
                  class="log-out {{if @noChrome "p-3" "p-2"}}"
                  {{on "click" (fn (mut this.showLogoutModal) true)}}
                >
                  {{t "controls.login.logout"}}
                </a>
              {{/if}}

              {{#if this.showLogoutModal}}
                <StandardModal
                  class="confirm-logout"
                  @onCancel={{fn (mut this.showLogoutModal) false}}
                  @onConfirm={{this.logOut}}
                  @size="sm"
                as |Modal|>
                  <Modal.header>
                    <h5>{{t "controls.login.logout"}}</h5>
                  </Modal.header>
                  <Modal.body>
                    <p class="fs-2">{{t "areyousure.logout"}}</p>
                  </Modal.body>
                  <Modal.footer />
                </StandardModal>
              {{/if}}
            </div>
          </menu.item>
        </div>
      </dd.menu>
    </BsDropdown>
  `, {
            component: this,
            eval () {
                return eval(arguments[0]);
            }
        });
    }
}
